import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { ArrowUpIcon } from '@sketchnote/icons';
import * as React from 'react';

import { CircleIcon } from './../Primitives/icons';
import { colors } from './ColorMenu';
import { editorIcons } from './EditorTools';

interface EditButtonProps {
  cmd: string;
  arg: string;
  name: string;
}

export const TextPanel = React.memo(function TextPanel() {
  return (
    <div className="flex gap-10 items-center cursor-pointer">
      <DropdownMenu.Root dir="ltr">
        <DropdownMenu.Trigger asChild>
          <div className="flex items-center gap-2 cursor-pointer">
            <CircleIcon fill="#000" stroke="white" />
            <ArrowUpIcon />
          </div>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content
          className="flex flex-row items-center justify-center gap-2 bg-primary-900 rounded-sm  "
          style={{ padding: '4px 8px', transform: 'translate(62px,-65px)' }}
        >
          {Object.keys(colors).map((color) => (
            <DropdownMenu.Item key={color} className="transform scale-90">
              <EditButton cmd="foreColor" name={color} arg={colors[color]} />
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Root>
      <div className=" text-gray-800">|</div>
      <EditButton cmd="bold" name="bold" arg="" />
      <EditButton cmd="italic" name="italic" arg="" />
      <EditButton cmd="underline" name="underline" arg="" />
      <EditButton cmd="strikethrough" name="strike" arg="" />
    </div>
  );
});

function EditButton(props: EditButtonProps) {
  return (
    <div
      key={props.cmd}
      onMouseDown={(evt) => {
        evt.preventDefault(); // Avoids loosing focus from the editable area
        document.execCommand('styleWithCSS', false, 'true');
        document.execCommand(props.cmd, false, props.arg); // Send the command to the browser
      }}
    >
      {props.cmd === 'foreColor' ? (
        <CircleIcon fill={props.name} stroke="white" />
      ) : (
        editorIcons[props.name]
      )}
    </div>
  );
}
